import { useCameraStore } from '../tracking/useCamera'

const labelByStatus: Record<string, string> = {
  idle: '摄像头未启用',
  requesting: '请求中…',
  granted: '摄像头已就绪',
  denied: '已被拒绝',
  unsupported: '不支持',
  error: '异常',
}

export function CameraBadge() {
  const status = useCameraStore((s) => s.status)
  const request = useCameraStore((s) => s.request)
  const stop = useCameraStore((s) => s.stop)

  const onClick = () => {
    if (status === 'granted') {
      if (confirm('停用摄像头？停用后将无法使用头部追踪与手势抓取。')) stop()
    } else {
      request()
    }
  }

  return (
    <button
      className={`camera-badge status-${status}`}
      onClick={onClick}
      aria-label={labelByStatus[status]}
      title={labelByStatus[status]}
    >
      <span className="dot" />
      <span className="label">{labelByStatus[status]}</span>
    </button>
  )
}
